import React from "react";
import classes from "./DotLoader.module.css";

const DotLoader = () => {
  return <div className={classes.dots}></div>;
};

export default DotLoader;
